import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/Auth";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen grid place-items-center" data-testid="auth-loading">
        <Loader2 className="w-6 h-6 animate-spin text-granate" />
      </div>
    );
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};
